// composables/useMyLikes.js
export const useMyLikes = () => {
  const { api } = useApi();
  const authState = useAuthState();

  // Set 대신 객체 사용 (SSR 호환)
  const likedMap = useState("myLikedMap", () => ({}));
  const isLoading = useState("myLikedLoading", () => false);
  const lastFetchAt = useState("myLikedFetchAt", () => 0);

  const MIN_INTERVAL = 3000;

  const fetchMyLikes = async (force = false) => {
    if (!authState.isAuthenticated.value) return;
    if (isLoading.value) return;
    if (!force && Date.now() - lastFetchAt.value < MIN_INTERVAL) return;

    isLoading.value = true;
    try {
      const response = await api("/api/csl/readLike", {});
      const list = response.result.likeList ?? [];
      
      // ✅ 객체로 저장 (key: cslKey, value: true)
      const next = {};
      list.forEach((item) => {
        next[Number(item.cslKey)] = true;
      });
      likedMap.value = next;
      
      lastFetchAt.value = Date.now();
    } catch (error) {
      console.error("내 찜 목록 조회 오류:", error);
    } finally {
      isLoading.value = false;
    }
  };

  if (import.meta.client) {
    fetchMyLikes();
  }

  // ✅ 객체 접근 방식
  const isLiked = (cslKey) => !!likedMap.value[Number(cslKey)];

  const addLike = (cslKey) => {
    likedMap.value = {
      ...likedMap.value,
      [Number(cslKey)]: true,
    };
  };

  const removeLike = (cslKey) => {
    const next = { ...likedMap.value };
    delete next[Number(cslKey)];
    likedMap.value = next;
  };

  const reset = () => {
    likedMap.value = {};
    lastFetchAt.value = 0;
  };

  return {
    likedMap,
    isLoading,
    fetchMyLikes,
    isLiked,
    addLike,
    removeLike,
    reset,
  };
};